export default [
  'bg',
  'ceb',
  'cs',
  'da',
  'de',
  'en',
  'es',
  'et',
  'fi',
  'fj',
  'fr',
  'hr',
  'ht',
  'hu',
  'hy',
  'id',
  'it',
  'km',
  'ko',
  'lv',
  'mg',
  'mn',
  'ms',
  'nl',
  'no',
  'pl',
  'pt',
  'ro',
  'ru',
  'sk',
  'sm',
  'sq',
  'sv',
  'th',
  'tl',
  'to',
  'uk',
  'zh',
]
